export default function (cookie) {
    function setCookie(name, value, expirity) {
        document.cookie = name + '=' + value + '; expires=' + expirity + ';';
    }

    function validateCookie(name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length == 2) {
            return parts.pop().split(';').shift();
        } else {
            return false;
        }
    }

    function prepareCookeBannerExpirity(days) {
        const cookieDate = new Date;
        cookieDate.setTime(cookieDate.getTime() + (days * 24 * 60 * 60 * 1000));
        return cookieDate.toGMTString();
    }

    const $cookieBanner = $('.js-cookiebanner');
    const $cookieBannerAccept = $cookieBanner.find('.js-cookiebanner-accept');
    const visitStatus = validateCookie(cookie);

    if (!visitStatus) {
        $cookieBanner.fadeIn();
    }

    $cookieBannerAccept.on('click', (e) => {
        e.preventDefault();
        setCookie(cookie, 'accepted', prepareCookeBannerExpirity(1000));
        $cookieBanner.fadeOut();
    });
}



// WEBPACK FOOTER //
// ../Resources/Private/JavaScript/features/cookiebanner.js